"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPagination = exports.StyledPages = exports.StyledPageNumber = exports.PrevNextWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var StyledPagination = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  line-height: 12px;\n  user-select: none;\n"])));

exports.StyledPagination = StyledPagination;

var StyledPageNumber = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  padding: 0 8px;\n  ", "\n  cursor: pointer;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &.active {\n    border-radius: 2px;\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('grey', '900')(props);
}, function (props) {
  return (0, _utils.getTypography)('body4')(props);
}, function (props) {
  return (0, _utils.getPalette)('white', '900')(props);
}, function (props) {
  return (0, _utils.getPalette)('primary', '400')(props);
});

exports.StyledPageNumber = StyledPageNumber;

var StyledPages = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  padding: 0px 16px;\n  align-items: center;\n"])));

exports.StyledPages = StyledPages;

var PrevNextWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: ", ";\n  &.disabled {\n    cursor: not-allowed;\n    color: ", ";\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('dark', '400')(props);
}, function (props) {
  return (0, _utils.getPalette)('grey', '300')(props);
});

exports.PrevNextWrapper = PrevNextWrapper;